import "./Login.scss";
import React, { useState, useContext } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link, useNavigate } from "react-router-dom";
import {
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
} from "firebase/auth";
import { auth } from "../../../firebase";
import { AuthContext } from "../../../context/AuthContext";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { loginUser } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      await signInWithEmailAndPassword(auth, email, password);

      //  without manually calling loginUser
      navigate("/stories");
    } catch (err) {
      console.error("Login error:", err);
      alert("Login failed. Please check your credentials.");
    }
  };

  const handleForgotPassword = async () => {
    if (!email) {
      alert("Please enter your email first.");
      return;
    }

    try {
      await sendPasswordResetEmail(auth, email);
      alert("Password reset email sent! Check your inbox.");
    } catch (err) {
      console.error(err);
      alert("Error sending password reset email.");
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center login-bg">
      <div className="p-3 login-form w-35">
        <form className="form-login" onSubmit={handleSubmit}>
          <h2 className="form-login__title">UnGriefMe</h2>
          <h3 className="form-login__sub-title">Sign In</h3>

          <div className="mb-3">
            <label className="form-login__label">Email</label>
            <input
              className="form-login__email"
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-login__label">Password</label>
            <input
              className="form-login__password"
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button className="btn btn-success w-100" type="submit">
            Sign In
          </button>

          <button
            type="button"
            className="form-login__forgot-pass btn btn-link mt-3 w-100"
            onClick={handleForgotPassword}
          >
            Forgot Password?
          </button>

          <Link
            to="/signup"
            className="form-login__signup-button btn btn-primary w-100"
          >
            Sign Up
          </Link>
        </form>
      </div>
    </div>
  );
}

export default Login;
